export const VOLUME = 'VOLUME' as const;
export const NAMESPACE = '_@@ezugi@@_' as const;
